import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { reduxKey } from './constants';
import { submitStatus, submitStatusSuccess, submitStatusFailure, submitStatusFailureDismiss } from './actions';
const defaultState = {
    isSubmitting: false,
    statusId: null,
    error: null
};
// submitStatusSuccess is fired by the saga just before redirecting to the
// status' canonical page. While the browser is loading, the reducer for that
// action keeps the submit button disabled by artifically continuing the
// appearance that it's still submitting.
//
// If redirection UX changes, keep in mind the isSubmitting flag.
const actionHandlers = {
    [submitStatus.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isSubmitting: true,
            error: null
        }),
    [submitStatusSuccess.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isSubmitting: true,
            statusId: action.payload.statusId,
            error: null
        }),
    [submitStatusFailure.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isSubmitting: false,
            error: action.payload.error
        }),
    [submitStatusFailureDismiss.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            error: null
        })
};
const reducers = {
    [reduxKey]: (state = defaultState, action)=>{
        if (!actionHandlers[action.type]) {
            return state;
        }
        return actionHandlers[action.type](state, action) || state;
    }
};
export default reducers;

//# sourceMappingURL=reducers.js.map